module.exports = __webpack_public_path__ + "img/page3-img.0f284e4a.png";